import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { handlePaymentRedirect } from '../../../helper/handlePaymentRedirect';
import {
  clearPendingPayment,
  getFreshPendingPayment,
  hasKnownPaymentRedirectParams,
  type PendingPayment,
} from '../../../helper/paymentPendingStorage';

export const PendingPaymentBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingPayment, setPendingPayment] = useState<PendingPayment | null>(() => getFreshPendingPayment());

  useEffect(() => {
    if (hasKnownPaymentRedirectParams(location.search)) {
      clearPendingPayment();
      setPendingPayment(null);

      return;
    }

    setPendingPayment(getFreshPendingPayment());
  }, [location.pathname, location.search]);

  if (!pendingPayment) {
    return null;
  }

  return (
    <div
      className='w-full bg-yellow-100 border border-yellow-300 px-4 pb-2 pt-1 md:px-8 md:pb-3 md:pt-2 flex flex-col md:flex-row items-stretch md:items-center justify-center md:justify-between shadow-sm'
      role='alert'
    >
      <p className='mb-2 md:mb-0 md:mr-4 text-center md:text-left text-xs sm:text-sm'>
        Sie haben einen noch nicht abgeschlossenen Bezahlvorgang. Wenn Sie bereits bezahlt haben, warten Sie bitte
        einige Minuten und prüfen Sie dann den Bereich Zahlungen.
      </p>
      <div className='w-full md:w-auto flex flex-col sm:flex-row gap-2'>
        <button
          onClick={() => handlePaymentRedirect(pendingPayment.novalnetUrl)}
          className='w-full sm:w-auto bg-primary hover:bg-primary-dark text-white font-semibold py-2 px-4 rounded-full transition-colors duration-150 ease-in-out text-sm sm:text-base text-center'
        >
          Zahlung fortsetzen
        </button>
        <button
          onClick={() => navigate('/payments')}
          className='w-full sm:w-auto bg-white hover:bg-gray-100 text-gray-800 border border-gray-300 font-semibold py-2 px-4 rounded-full transition-colors duration-150 ease-in-out text-sm sm:text-base text-center'
        >
          Zahlungen prüfen
        </button>
      </div>
    </div>
  );
};
